// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"165":"42ee2efbcbeb18e7","2977":"ccc11b97b2c2a7af","3367":"54795220be7b6b2b","6625":"a0e021c7f78911fc"}[chunkId] + ".css";
};